import { styled } from '@mui/material/styles';
import { Card, CardContent, FormControlLabel, Typography, Select, TextField } from '@mui/material';
import { commonStyles } from '../../../assets/styles/commonStyles';

export const StyledCard = styled(Card)(({ theme }) => ({
  ...commonStyles.enhancedCard(theme),
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  ...commonStyles.cardContentWithOverflow(),
}));

export const ControlsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(3),
  flexWrap: 'wrap',
  
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
  },
}));

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  ...commonStyles.responsiveFormLabel(theme),
  ...commonStyles.enhancedCheckbox(),
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  ...commonStyles.responsiveText(theme),
  ...commonStyles.brandText(),
}));

export const StyledSelect = styled(Select<string>)(({ theme }) => ({
  minWidth: '120px',
  maxWidth: '150px',
  ...commonStyles.enhancedFormControl(theme),
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  minWidth: '200px',
  maxWidth: '300px',
  ...commonStyles.enhancedFormControl(theme),
}));
